/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import LearnUtilsHome from '../../containers/Learn/LearnUtils';
import DiscoverAnalytics from '../../../utils/DiscoverAnalytics';

import {LearnGetStarted, DiscoverUtils} from 'discover-hub';

/* eslint-enable no-unused-vars */
import './LearnHome.scss';
import {DeviceDetectionUtil} from 'cchome-shared/utils';

const analytics = new DiscoverAnalytics();

interface Props {
	locale: string;
	env: string;
	productEntitlements: Array<string>;
	customerSegment: string;
	onTop: boolean;
	showSkeletonUI: boolean;
	forceHideLearnHome: boolean;
	location: Location;
	history: Array<string>;
	intl: Object;
}

type State = {
	learnDataError: boolean;
};

export class LearnHome extends Component<Props, State> {
	useGridSkeleton: boolean;

	constructor(props: Props) {
		super(props);

		this.state = {
			learnDataError: false,
		};
		this.useGridSkeleton = true;
	}

	setLearnDataError(value: boolean) {
		this.setState({learnDataError: value});
	}

	componentWillMount() {
		this.useGridSkeleton = window.cchome.util.hasFeature('Recent_Grid_Skeleton');
	}

	/**
	 * Navigates to the given learn content given parameters
	 * from the child.
	 * NOTE: This is different from the onLearnPathChange seen in
	 * other files. This primarily ONLY deals with Tutorial pages.
	 *
	 * @param {Array<Object>} learnSignals
	 */
	onLearnPathChange(learnSignals: Array<any>) {
		// TODO: we need to consolidate all of these methods
		// that are the same ... somehow, somewhere

		let newPath = this.props.location.pathname;
		let isTutorial = false;

		learnSignals.reduce((params, signal) => {
			const signalValue = signal.value;

			if (signal.type === 'tutorial') {
				isTutorial = true;
				// NOTE: THIS LOGIC IS DIFFERENT FROM LEARNDISCOVER
				// This tutorial ensures that learn is the first and foremost
				// path variable.
				// If it is not then history gets an error when trying to push
				const extraPath = `${signalValue.app}/${signalValue.level}/${signalValue.field}/${signalValue.playlistId}/${signalValue.tutorialId}`;
				newPath = `/cc/discover/learn/${extraPath}`;
			}
			else if (signal.type === 'app') {
				let extraPath = `${signalValue.app}`;
				if (signalValue.level) {
					const queryParams = DiscoverUtils.getSearchPath({
						experienceLevel: signalValue.level,
					});

					extraPath = `${extraPath}/${queryParams}`;
				}
				const appPath = signalValue.app;
				if (appPath) {
					newPath = `/cc/discover/learn/app/${extraPath}`;
				}
				else {
					newPath = '/cc/discover/learn';
					// a fall back in case for some reason app is not provided
				}
			}

			return params;
		}, {});

		this.props.history.push(`${newPath}`);
	}

	/**
	 * Returns the string path generated from learn signals.
	 * TODO: This has common logic with onLearnPathChange, refactor this
	 *
	 * @param {Array<Object>} learnSignals
	 * @returns {string} - string version of the path
	 */
	generateLearnPath(learnSignals: Array<any>) {
		let newPath = this.props.location.pathname;
		let isTutorial = false;

		learnSignals.reduce((params, signal) => {
			const signalValue = signal.value;

			if (signal.type === 'tutorial') {
				isTutorial = true;
				// NOTE: THIS LOGIC IS DIFFERENT FROM LEARNDISCOVER
				// This tutorial ensures that learn is the first and foremost
				// path variable.
				// If it is not then history gets an error when trying to push
				const extraPath = `${signalValue.app}/${signalValue.level}/${signalValue.field}/${signalValue.playlistId}/${signalValue.tutorialId}`;
				newPath = `/cc/discover/learn/${extraPath}`;
			}
			else if (signal.type === 'app') {
				let extraPath = `${signalValue.app}`;
				if (signalValue.level) {
					const queryParams = DiscoverUtils.getSearchPath({
						experienceLevel: signalValue.level,
					});

					extraPath = `${extraPath}/${queryParams}`;
				}
				const appPath = signalValue.app;
				if (appPath) {
					newPath = `/cc/discover/learn/app/${extraPath}`;
				}
				else {
					newPath = '/cc/discover/learn';
					// a fall back in case for some reason app is not provided
				}
			}

			return params;
		}, {});

		return newPath;
	}

	render() {
		// const isEnterprise = this.props.customerSegment && this.props.customerSegment.toLowerCase() === 'enterprise';
		// enterprise users should not see learn ... for now ???
		// TODO: ask roland again for this logic b/c Learn tab does not show for Enterprise

		if (DeviceDetectionUtil.isInternetExplorer()) {
			return null;
		}

		return (
			<div
				className={
					this.props.onTop
						? 'learn-home-container-top home-component'
						: 'learn-home-container-bottom home-component'
				}
			>
				<div className='learn-home-content'>
					<LearnGetStarted
						env={this.props.env}
						imsData={LearnUtilsHome.getIMSData()}
						locale={this.props.locale}
						featureFlags={window.cchome.util.getAllFeatures()}
						categoryType={'learn'}
						onLearnPathChange={data => this.onLearnPathChange(data)}
						generateLearnPath={data => this.generateLearnPath(data)}
						intl={this.props.intl}
						logger={window.cchome.util.logger}
						postAnalytics={data => analytics.postCustomData(data)}
						signedIn
					/>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		learnapps: state,
		productEntitlements: state.profile.productEntitlements,
		forceHideLearnHome: state.app.forceHideLearnHome,
	};
}

export default connect(mapStateToProps, {})(LearnHome);
